"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetWxSignatureForJktRequest = void 0;
var GetWxSignatureForJktRequest = /** @class */ (function () {
    function GetWxSignatureForJktRequest() {
    }
    return GetWxSignatureForJktRequest;
}());
exports.GetWxSignatureForJktRequest = GetWxSignatureForJktRequest;
;
//# sourceMappingURL=getWxSignatureForJkt.request.js.map